export default __webpack_public_path__ + "images/af87737a-logo-100x22-violet.svg";